import './UnexpectedJobModal.scss';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import Error from '../../../../common/Error/Error';
import LoadingSpinner from '../../../../common/LoadingSpinner/LoadingSpinner';
import GoodsIn from '../../../../api/controllers/GoodsIn/GoodsIn';
import Checkbox from '../../../../common/Checkbox/Checkbox';
import Hub from '../../../../api/controllers/Hub/Hub';
import Button from '../../../../common/Button/Button';

// General UnexpectedJobModal Component
const UnexpectedJobModal = ({
  category,
  movementId,
  setModalOpen,
  assignments,
  refreshMovement,
  setDisplayAssignment,
}) => {
  const [error, setError] = useState();
  const [loading, setLoading] = useState();
  const [total, setTotal] = useState(1);
  const [selectedJob, setSelectedJob] = useState();
  const [hubs, setHubs] = useState();

  const unloadUnexpected = () => {
    setLoading(true);
    GoodsIn.updatePackageCount(category, movementId, selectedJob, total)
      .then(() => {
        setLoading(false);
        setDisplayAssignment(assignments?.find(assignment => assignment?.job?.id == selectedJob));
        refreshMovement();
        setModalOpen(false);
      })
      .catch(e => {
        setLoading(false);
        setError(e.errors || e.error);
      });
  };

  const getHubs = () => {
    setLoading(true);
    Hub.all()
      .then(response => {
        setLoading(false);
        setHubs(response.items);
      })
      .catch(e => {
        setLoading(false);
        setError(e.errors || e.error);
      });
  };

  useEffect(() => {
    setSelectedJob(assignments[0]?.job?.id);
    setTotal(assignments[0]?.quantity);
  }, [assignments]);

  useEffect(() => {
    getHubs();
  }, []);

  return (
    <div className="unexpected_job_container">
      {loading && <LoadingSpinner />}
      {error && (
        <Error
          errorMessages={error}
          type={'error'}
          errorTitle={
            Array.isArray(error)
              ? `${error.length} error${error.length > 1 ? 's' : ''} occurred: `
              : ''
          }
        />
      )}
      <div className="affected_packages">
        {assignments?.length > 0
          ? 'The following additional jobs are associated with this trailer:'
          : 'No other jobs are expected to be present on this trailer booking; contact a member of operations if you think that this needs to be corrected.'}
      </div>
      {assignments?.length > 0 &&
        assignments?.map(assignment => {
          return (
            <div className="assignment_checkbox_container" key={assignment?.id}>
              <Checkbox
                selected={assignment?.job?.id == selectedJob}
                handleClick={() => {
                  setSelectedJob(assignment?.job?.id);
                  setTotal(assignment?.quantity);
                }}
                label={`unexpected_package_${assignment?.job?.jobReference}`}
              />
              <div className="assignment_details">
                <div className="assignment">
                  {assignment?.destinationHubId != null
                    ? `${assignment?.job?.jobReference} - Expected to offload at ${
                        hubs?.find(hub => hub.id == assignment?.destinationHubId)?.name
                      }`
                    : `${assignment?.job?.jobReference} - No destination hub specified`}
                </div>
                <div className="details">
                  {assignment?.job?.shipper?.name} ({assignment?.quantity}{' '}
                  {assignment?.job?.packageType?.shortName}, {assignment?.grossWeightKg} kg,{' '}
                  {assignment?.cubicMetres} m³)
                </div>
              </div>
            </div>
          );
        })}
      {assignments?.length > 0 && (
        <>
          <div className="num_of_packages_container">
            <input
              data-testid={'package_number_input'}
              className="number_of_packages"
              type="number"
              value={total}
              onChange={e => setTotal(e.target.value)}
            />
            <div className="block_label">packages</div>
          </div>
          <div className="unexpected_job_buttons">
            <Button
              className="unload_button"
              onClick={() => unloadUnexpected()}
              label="Unload this job"
            />
          </div>
        </>
      )}
    </div>
  );
};

UnexpectedJobModal.propTypes = {
  category: PropTypes.string,
  movementType: PropTypes.string,
  movementId: PropTypes.number,
  setModalOpen: PropTypes.func,
  refreshMovement: PropTypes.func,
  assignments: PropTypes.array,
  setDisplayAssignment: PropTypes.func,
};

export default UnexpectedJobModal;
